import Form from "./Form";

export default function AddBook() {
  return (
    <>
      <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
      <Form />
    </>
  );
}
